import { METRO_LOOKUP_MAP } from './metadata/METRO_LOOKUP';

export default function findMetroOrNull(
  serviceRegionName: string | null | undefined,
): string | null {
  if (serviceRegionName == null) {
    return null;
  }

  return METRO_LOOKUP_MAP[serviceRegionName] ?? null;
}
